import { AlphaSBoxIcon } from './AlphaSBoxIcon';

/**
 * author: GreenTurtwig
 * id 2BC531B2-987E-411F-B3AE-3686F24F3B05
 * name alpha-s-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-s-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterSBoxIcon = AlphaSBoxIcon;
export default LetterSBoxIcon